import clone from 'lodash/clone';

import EventManager from "../../store/sqftEventManager";
import config from "../../store/sqftConfig";
import workspace from "../workspace";
import {
  getBacksplashArea,
  getEdgeLength,
  getPointField,
  isPointInsideShape,
  mmToM
} from "../../../../helpers/sqftHelper";
import ShapeHelper, {getEdgeFeatures} from "../../../../helpers/shapeHelper";
//import $ from "jquery";
import {
  APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE,
  MOVABLE_IMAGE_TYPES, SIDEBAR_BUTTONS_MENU,
  SIDEBAR_SLAB_BUTTONS
} from "../../../../constants";
import store from "../../../../../../store";
import PointV2, {CORE_POINT_LAYOUTS} from "./pointV2";
import RenderMovableImage from "./imageParts/renderMovableImage";
import sqftShape from "./sqftShape";
import ShapeAbsolute from "./shapeParts/shapeAbsolute";
//import point from "./point";
import {createImageLinesFromPoints, getImagePoint} from "../../helpers/movableImageHelper";
import workspaceControllers from "../../store/workspaceControllers";
import {hardCodeIsCaesarStone} from "../../../../../../misc/fabricatorHardcode";
import ShapeAutoShuffle from "./shapeParts/shapeAutoShuffle";
import GlobalEventManager from "../../store/GlobalEventManager";
import ShapeIntersections from "./shapeParts/shapeIntersections";
import {getCurrentLayout} from "../../../../../appLayout";
import {initTitle} from "../controls/labels/labelsHelper";
import sqftSlabManager from "../../store/sqftSlabManager";
import sqftImageManager from "../../store/sqftImageManager";
import sqftShapeIntersectionsManager from "../../store/sqftShapeIntersectionsManager";
import SqftStore from "../../store/sqftStore";
//import LineImage from "./imageParts/lineImage";

class MovableImage {
  image = null;
  initialSize = {
    width: 12,
    depth: 12,
    height: 12,
  };
  size = {
    width: 12,
    depth: 12,
    height: 12,
  };
  hoverColor = "#6495ED";
  // debugLineColor = "rgba(0,255,0,0.3)",
  // debugPointColor = "rgba(0,0,255,0.3)",
  //fillColor = "rgba(255,255,255,0)",
  attachedTo = null;
  type;
  part;
  partId; // same as subType
  shapeRotatable;
  shapeType = "square";
  renderMovableImage = null; //new RenderMovableImage(this);
  shapeAutoShuffle = new ShapeAutoShuffle(this);
  shapeIntersections = new ShapeIntersections(this);

  constructor(id, priority = null, subType, params) {
    this.id = id;
    this.priority = priority;
    this.subType = subType;
    this.partId = subType;
    this.pos = { x: 0, y: 0 };
    this._state = {
      mouseDown: false,
      mouseDownPosition: null,
      mouseDownSize: null,
      hovering: false,
      isRotatable: false,
      minimumDepth: 1,
      minimumWidth: 1,
    };
    this.rotatedDegrees = 0;
    this.rotatedDegreesSlab = 0;
    this.featureId = id;
    this.pricePerArea = 0;
    this.isHidden = false;
    this.isDisabledInPopup = false;
    this.Direction = {
      RIGHT: 0,
      LEFT: 1
    };
    this.FlipDirection = {
      HORIZONTAL: 0,
      VERTICAL: 1
    };
    this.resizablePoint = null;
    this.onClicked = null;
    this.shapeAbsolute = new ShapeAbsolute(this); // this is used to snap images
    this.params = params

    //this.initEvents();
  }

  //private methods
  _setFillColor = (red, green, blue, alpha) => {
    let fillColor =
      "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
    void fillColor;
  }
  _setImage = (value) => { this.image = value; }
  _setAttachedTo = (value) => {
    if (value) {
      this.attachedTo = value;
    }
  }
  _setHovering = (value) => {
    this._state.hovering = value;
    return value;
  }
  _snappedPos = () => {
    let scaledGridSize = config.workspace.getScaledGridSize();

    let newX = Math.round(this.pos.x / scaledGridSize) * scaledGridSize;
    let newY = Math.round(this.pos.y / scaledGridSize) * scaledGridSize;
    return {
      x: newX,
      y: newY
    };
  }

  _moveImage = (mousePos) => {
    const scale = workspace.getScale();
    let xDiff = (this._state.mouseDownPosition.x - mousePos.x) / scale;
    let yDiff = (this._state.mouseDownPosition.y - mousePos.y) / scale;

    this.updateSnappedPos();

    this.pos.x -= xDiff;
    this._state.mouseDownPosition.x = mousePos.x;

    this.pos.y -= yDiff;
    this._state.mouseDownPosition.y = mousePos.y;
  };

  resetAbsolutePos = () => {
    if (this.params.canSnap) {
      this.shapeAbsolute.setAbsolutePos(null); //reset minLength for correct calculations without stacking
      this.shapeAbsolute.setSnappedWithShape(null);
      this.shapeAbsolute.setSnappedShapeGroup(null);
    }
  }

  resetState = () => {
    this._state.mouseDown = false;
    this._state.mouseDownPosition = null;
    this._state.mouseDownSize = null;
    this._state.hovering = false;
    this._state.isRotatable = false;
  };

  updateLinesLength = () => {
    for (const line of this.getLines()) {
      line.updateLineLength();
    }
  }

  updateSnappedPos = () => {
    if (this.params.canSnap) {
      this.shapeAbsolute.setAbsolutePos(null); //reset minLength for correct calculations without stacking
      this.shapeAbsolute.setSnappedWithShape(null);
      this.shapeAbsolute.setSnappedShapeGroup(null);

      //let distancesToWalls = ShapeHelper.getDistancesToWalls(this);
      let distancesToShapes = ShapeHelper.getDistancesToShapes(this);
      let distancesToImages = ShapeHelper.getDistancesToImages(this);
      //console.log("distancesToWalls", distancesToWalls);
      //console.log("distancesToShapes", distancesToShapes);
      //console.log("distancesToImages", distancesToImages);

      let snapPossibilitiesToShapes = ShapeHelper.getSnappingPossibilities(distancesToShapes);
      let snapPossibilitiesToImages = ShapeHelper.getSnappingPossibilities(distancesToImages);
      //let snapPossibilitiesToWalls = ShapeHelper.getSnappingPossibilities(distancesToWalls);
      //console.log("snapPossibilitiesToShapes", snapPossibilitiesToShapes);

      //walls
      // let [absolutePosToWalls, snappedWithWalls] = ShapeHelper.getAbsolutePosFromSnapPossibilities(snapPossibilitiesToWalls, this.pos);
      // if (absolutePosToWalls) {
      //   this.shapeAbsolute.setAbsolutePos(absolutePosToWalls);
      //   void snappedWithWalls;
      //   //snappedWithImage.shapeAbsolute.setSnappedWithImage(this);
      // }

      //shapes
      let [absolutePosToShapes, snappedWithShape] = ShapeHelper.getAbsolutePosFromSnapPossibilities(snapPossibilitiesToShapes, this.pos);
      if (absolutePosToShapes) {
        this.shapeAbsolute.setAbsolutePos(absolutePosToShapes);
        snappedWithShape.shapeAbsolute.setSnappedWithShape(this);
        workspaceControllers.snappedShapeGroups.setSameSnappedShapesGroup(this, snappedWithShape);
      }

      //images
      let [absolutePosToImages, snappedWithImage] = ShapeHelper.getAbsolutePosFromSnapPossibilities(snapPossibilitiesToImages, this.pos);
      if (absolutePosToImages) {
        this.shapeAbsolute.setAbsolutePos(absolutePosToImages);
        workspaceControllers.snappedShapeGroups.setSameSnappedShapesGroup(this, snappedWithImage);
        //snappedWithImage.shapeAbsolute.setSnappedWithImage(this);
      }
    }
  }

  _isMouesOverImage = (mousePos) => {
    let scale = workspace.getScale();
    let offset = workspace.getOffset();
    let realPos = {
      x: (this.pos.x * scale) + offset.x,
      y: (this.pos.y * scale) + offset.y
    };
    let realSize = {
      width: this.size.width * scale,
      depth: this.size.depth * scale
    };
    let axis = {
      x: realPos.x + (realSize.width / 2),
      y: realPos.y + (realSize.depth / 2)
    }
    let points = [
      this._getRotatedPoint({x: realPos.x, y: realPos.y}, axis, this.rotatedDegrees),
      this._getRotatedPoint({x: realPos.x + realSize.width, y: realPos.y}, axis, this.rotatedDegrees),
      this._getRotatedPoint({x: realPos.x + realSize.width, y: realPos.y + realSize.depth}, axis, this.rotatedDegrees),
      this._getRotatedPoint({x: realPos.x, y: realPos.y + realSize.depth}, axis, this.rotatedDegrees)
    ];

    let maxX = points[0].x;
    let maxY = points[0].y;
    let minX = points[0].x;
    let minY = points[0].y;

    for (let i = 0; i < points.length; i++) {
      let point = points[i];
      if (maxX < point.x)
        maxX = point.x;
      if (minX > point.x)
        minX = point.x;
      if (maxY < point.y)
        maxY = point.y;
      if (minY > point.y)
        minY = point.y;
    }

    const isHovering = mousePos.x > minX && mousePos.y > minY && mousePos.x < maxX && mousePos.y < maxY;
    this._setHovering(isHovering);

    return isHovering;
  };

  _getRotatedPoint(point, around, angle) {
    let s = Math.sin(angle);
    let c = Math.cos(angle);
    point.x -= around.x;
    point.y -= around.y;

    let newPoint = {
      x: point.x * c - point.y * s,
      y: point.x * s + point.y * c
    };

    return {
      x: newPoint.x + around.x,
      y: newPoint.y + around.y
    };
  }

  //private event handles
  _onMouseMove(mousePos, e) {
    const isLineLengthActive = document.querySelector(".line-input");
    if (e.terminate) {
      this._setHovering(false);
      return false;
    }
    //console.log("this._isMouesOverImage(mousePos)", this._isMouesOverImage(mousePos));
    if (this._isMouesOverImage(mousePos) && !isLineLengthActive) {
      EventManager.setCursor('move', this)
      if (this._state.mouseDown) {
        this._moveImage(mousePos);

        return true;
      }
    }

    //smooth scrolling
    if (this._state.mouseDown && !isLineLengthActive) {
      this._moveImage(mousePos);
    }

    return false;
  }

  _onMouseUp(mousePos, e) {
    void mousePos;
    void e;
    EventManager.releaseStealLock(this);
    if (this._state.mouseDown) {
      this.shapeAutoShuffle.handlePlaceShapeOnTheLine();
    }
    this.shapeAutoShuffle.clearDragStartState();
    this._state.mouseDown = false;
    this._state.mouseDownPosition = null;
    this._state.mouseDownSize = null;

    //Update slab features
    const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();
    const slabImages = sqftImageManager.getSlabImages();
    if (slabImages.length || slabPlaceHolderShapes.length) {
      sqftShapeIntersectionsManager.updateShapesIntersections();
      this.shapeIntersections.handleSlabPlaceholderAndSlabImageIntersections();
    }
  }

  _onGlobalMouseUp(e) {
    if (this._state.mouseDown) {
      this._onMouseUp({ x: e.clientX, y: e.clientY }, e);
    }
  }

  _onMouseDown = (mousePos, e) => {
    void e;
    //if not then handle event with this object
    if (this.isHovering()) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      const isShowSlabTool = reduxState.sqftSlabState.isShowSlabTool;

      //Delete this
      if (activeButton === SIDEBAR_SLAB_BUTTONS.delete && isShowSlabTool) {
        workspace.removeSlabImage(this);
      }

      //Move self
      if (EventManager.getCursor().indexOf("move") >= 0 || activeButton === SIDEBAR_BUTTONS_MENU.move) {
        this.shapeAutoShuffle.captureDragStartState();
        this._state.mouseDown = true;
        this._state.mouseDownPosition = mousePos;
        this._state.mouseDownSize = this.getSize();
      }
      return true;
    }
    return false;
  }

  //public methods
  setPricePerArea = (val) => { this.pricePerArea = clone(val) };
  setPosition = (value) => { this.pos = value; }
  setId = (id) => { this.id = id };
  setFeatureId = (featureId) => {
    this.featureId = featureId;
    this.feature = null;
    if (this.type === MOVABLE_IMAGE_TYPES.slabImage) {
      const labelText = this.getFeature()?.getFeatureName();
      initTitle(labelText, this.partId, this);
      if (!SqftStore.isSlabMode()) {
        this.deregisterLineEvents();
      }
    }
  };
  getFeature = () => {
    if (!this.feature) {
      const layout = getCurrentLayout();
      this.feature = layout.getFeatureById(this.featureId, true);
    }
    return this.feature
  }
  getIsRotatable = () => { return this._state.isRotatable };
  getState = () => { return this._state };
  setIsRotatable = (isRotatable) => { this._state.isRotatable = isRotatable};
  setRotationDegrees = (rotationDegrees) => {
    this.rotatedDegrees = rotationDegrees
  }
  getCenter = () => {
    return {
      x: this.size.width / 2,
      y: this.size.depth / 2
    }
  }
  getCenterPosition = () => {
    const center = this.getCenter();
    const position = this.getPosition();

    return {
      x: position.x + center.x,
      y: position.y + center.y
    }
  }

  setSize = (value) => {
    this.size.width = value.width;
    this.size.depth = value.depth;
  }

  setInitialSize = (value) => {
    this.initialSize.width = value.width;
    this.initialSize.depth = value.depth;
  }

  getPosition = () => {
    let absolutePos = this.shapeAbsolute.getAbsolutePosition();

    return absolutePos !== null ? absolutePos : this.pos;
  };

  getSnappedPosition = () => { return this._snappedPos(); };

  getPosField = () => {
    let position = this.getPosition();
    const workspacePos = workspace.getOffset();
    const scale = workspace.getScale();

    return {
      x: workspacePos.x + ((position.x + (this.size.width / 2)) * scale),
      y: workspacePos.y + ((position.y + (this.size.depth / 2)) * scale)
    }
  };

  getOffset = () => {
    const scale = config.scale;
    const workspacePos = workspace.getOffset();
    let _pos = this.getPosition();
    if (config.workspace.snapToGrid) {
      _pos = this.getSnappedPosition();
    }
    return {
      x: workspacePos.x + (_pos.x * scale),
      y: workspacePos.y + (_pos.y * scale)
    }
  };

  isHovering = () => {
    //console.log("this._state.hovering", this._state.hovering);
    return this._state.hovering === true;
  };
  getAttachedTo = () => { return this.attachedTo; };
  getImage = () => { return this.image; };
  getSize = () => { return this.size; };
  getInitialWidth = () => { return this.initialSize.width }
  getInitialDepth = () => { return this.initialSize.depth }
  getInitialHeight = () => { return this.initialSize.height }
  getWidth = () => { return this.getSize().width; };
  getDepth = () => { return this.getSize().depth; };
  getHeight = () => { return this.getSize().height; };

  //getThickness = () => { return this.getSize().thickness; };
  getRotation = () => { return this.rotatedDegrees; };
  getOriginalPointsCoords = () => { return [] };
  getPointsCoords = () => { return [] };
  getImageData = () => {
    const image = this.image || {};
    const imageDataset = image.dataset || {};

    return {
      src: image.currentSrc || image.src || image.getAttribute && image.getAttribute('src') || '',
      id: imageDataset.id || image.id,
      name: imageDataset.name || image.name,
      nameMetric: imageDataset.nameMetric || image.nameMetric,
      width: image.width,
      depth: image.depth
    };
  };
  export = () => {
    let linesData = [];
    const Lines = this.getLines();
    for (const lineIndex in Lines) {
      if (Lines.hasOwnProperty(lineIndex)) {
        linesData.push({lineIndex, ...Lines[lineIndex].exportData()});
      }
    }
    const imageData = this.getImageData();

    let exportData = {
      pos: this.pos,
      id: this.id,
      featureId: this.featureId ? this.featureId : imageData.id, // image id old support
      image: imageData,
      type: this.type,
      subType: this.subType,
      partId: this.partId,
      part: this.part,
      size: this.size,
      rotatedDegrees: this.rotatedDegrees,
      rotatedDegreesSlab: this.rotatedDegreesSlab,
      attachedTo: this.attachedTo ? this.attachedTo.id : null,
      attachedToParentId: this.attachedTo
        ? this.attachedTo.getParent
          ? this.attachedTo.getParent().id
          : null
        : null,
      isDisabledInPopup: this.isDisabledInPopup,
      pricePerArea: this.pricePerArea,
      priority: this.priority,
      shapeAbsoluteData: this.shapeAbsolute ? this.shapeAbsolute.export() : null,
      linesData: linesData,
    };
    if (this.attachedTo && this.attachedTo.getLineLength){
      exportData.lineLength = config.measureUnit === "Metric" ? mmToM(this.attachedTo.getLineLengthMm()) : this.attachedTo.getLineLength();
      exportData.partId = this.attachedTo.getParent().partId;
    }
    if (this.type === "edge") {
      const navItems = getEdgeFeatures();
      let edge = navItems.find(edge => edge.part.dbFeature.id === +imageData.id);
      let unit = edge ? edge.unit : null;
      exportData.length = (unit ? unit.toLowerCase() : null) === "each"
        ? 1
        : config.measureUnit === "Imperial" ? getEdgeLength(this.attachedTo) : mmToM(getEdgeLength(this.attachedTo));
    } else if (this.type === "backsplash") {
      exportData.length = getBacksplashArea(this.attachedTo.getBacksplashHeight(), this.attachedTo);
    } else if (this.type === "wall") {
      exportData.length = exportData.lineLength;
    }

    return exportData;
  };
  importData = (importData) => {
    const skipImportProps = ['image', 'shapeAbsolute', 'linesData'];
    Object.keys(importData).forEach(key => {
      if (importData.hasOwnProperty(key)) {
        if (!skipImportProps.includes(key)) {
          this[key] = importData[key];
        }
      }
    });
    // compatibility (can be removed in future)
    if (!this.size.depth && this.size.thickness) {
      this.size.depth = this.size.height
      this.size.height = this.size.thickness
    }
    if (importData.shapeAbsoluteData) {
      this.shapeAbsolute.import(importData.shapeAbsoluteData);
    }
    if (importData.linesData) {
      for (const lineData of importData.linesData) {
        const line = this.lines.find(line => line.lineIndex === +lineData.lineIndex);
        if (line) {
          line.importData(lineData);
        }
      }
    }
  }
  //todo sqft-react is this needed?
  // generateImage = (value, shapes) => {
  //   let domImg = document.createElement('img');
  //   domImg.crossOrigin = "Anonymous";
  //   let $img = $(domImg);
  //   $img.css({
  //     position: 'absolute',
  //     width: '1px',
  //     height: '1px'
  //   });
  //   $img.attr({
  //     'data-id': value.image.id,
  //     'data-name': value.image.name,
  //   });
  //   let attachedTo = null;
  //   if (value.attachedTo) {
  //     for (let i = 0; i < shapes.length; i++) {
  //       let shape = shapes[i];
  //       if (shape.getLines && !attachedTo) {
  //         let lines = shape.getLines();
  //         for(let n = 0; n < lines.length; n++) {
  //           let line = lines[n];
  //           if ( line.id == value.attachedTo && !attachedTo ) {
  //             attachedTo = line;
  //           }
  //         }
  //       }
  //     }
  //   }
  //   $img.appendTo($('body'));
  //   $img.attr('src', (config.isKiosk || value.image.src.includes('data:image') ? '' : '/api/SqFtCalc/GetImage?url=') + value.image.src);
  //   return {
  //     image: domImg,
  //     attachedTo: this.attachedTo
  //   };
  // };
  getTotalInches = function() {
    return 0;
  };

  /**
   * Public functions
   * @param flipDirection
   */
  flip = function(flipDirection) {
    void flipDirection
  };
  rotate = (degrees, direction) => {
    //todo slab rotation QCDES-1358
    if (this.type === MOVABLE_IMAGE_TYPES.slabImage) {
      return
    }
    const isSlabMode = store.getState().sqftSlabState.isShowSlabTool;
    isSlabMode ? this.rotatedDegreesSlab += degrees : this.rotatedDegrees += degrees;
    (this.rotatedDegrees === 360) && (this.rotatedDegrees = 0);
    (this.rotatedDegreesSlab === 360) && (this.rotatedDegreesSlab = 0);

    direction = direction || this.Direction.Right;
    let angle = (degrees * Math.PI / 180);
    if (direction === this.Direction.LEFT)
      angle *= -1;
    if (this.shapeRotatable) {
      this.shapeRotatable.rotateShapeRotatablePoints(this.getCenter(), angle, isSlabMode);
    }
    this.rotateBorderPoints(angle);
  };
  rotateBorderPoints = (angle) => {
    const center = this.getCenter();
    for (const linePoint of this.getLinePoints()) {
      linePoint.rotate(center, angle);
    }
  }
  init = (position, image, size, attachedTo, isHidden) => {
    this.setPosition(position);
    this._setImage(image);
    this.setSize(size);
    this.setInitialSize(size);
    this._setAttachedTo(attachedTo);
    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
    this._setFillColor(getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255), 0.3);
    if (isHidden) {
      this.isHidden = true;
    } else {
      this.initEvents();
      //this.initResizablePoint(position);
    }
    this.lines = this.createLines();
    //hide lines for slab images
    if (this.type === MOVABLE_IMAGE_TYPES.slabImage) {
      this.deregisterLineEvents();
    }

    this.renderMovableImage = new RenderMovableImage(this);
  };
  initEvents = () => {
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this._onMouseMove,
      this,
      this.priority ? this.priority : EventManager.priorities.IMAGE - (this.attachedTo ? 1 : 0)
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this._onMouseDown,
      this,
      this.priority ? this.priority : EventManager.priorities.IMAGE - (this.attachedTo ? 1 : 0)
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this._onMouseUp,
      this,
      this.priority ? this.priority : EventManager.priorities.IMAGE - (this.attachedTo ? 1 : 0)
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      this._render,
      this,
      this.priority ? this.priority : EventManager.priorities.IMAGE - (this.attachedTo ? 1 : 0)
    );
    GlobalEventManager.addEvent('mouseup', this._onGlobalMouseUp, this);
  };

  /**
   * Not used
   */
  initResizablePoint = () => {
    let pointParams = {
      priority: EventManager.priorities.BOX_POINT,
      movable: true,
      isCentered: true,
      isVisibleOnHover: true,
      moveCallback: (mousePos, movable) => {
        //const movablePoint = movable.parent;
        const movableImage = movable.grandParent;
        //const size = movableImage.getSize();
        const state = movableImage.getState();
        let scale = workspace.getScale();
        let xDiff = (movable.state.mouseDownPosition.x - mousePos.x) / scale;
        let yDiff = (movable.state.mouseDownPosition.y - mousePos.y) / scale;
        // const newWidth = movable.state.mouseDownSize.width - xDiff;
        // const newHeight = movable.state.mouseDownSize.height - yDiff;
        const newWidth = (movable.state.mouseDownSize.width - xDiff + movable.state.mouseDownSize.depth - yDiff) / 2;
        const newDepth = (movable.state.mouseDownSize.depth - yDiff + movable.state.mouseDownSize.width - xDiff) / 2;

        if (newDepth >= state.minimumDepth && newWidth >= state.minimumWidth ) {
          movableImage.setSize({
            width: newWidth,
            depth: newDepth
          });
          movable.posX = newWidth;
          movable.posY = newDepth;
        }
      },
      mouseUpCallback: (mousePos, movable) => {
        movable.state.mouseDownSize = null
      },
      mouseDownCallback: (mousePos, movable) => {
        const movableImage = movable.grandParent;
        movable.state.mouseDownSize = {...movableImage.getSize()};
      }
    };
    let pointDesign = {
      radius: 10,
      lineWidth: 1,
      layout: CORE_POINT_LAYOUTS.resize
    };
    //const position = this.getPosition();
    const size = this.getSize();
    const pointPositionX = size.width;
    const pointPositionY = size.depth;
    this.resizablePoint = new PointV2(pointPositionX, pointPositionY, this, pointParams, pointDesign);
  }

  deregisterEvents = () => {
    EventManager.removeEvent(this);
    this.isHidden = true;
    this.deregisterLineEvents();
    GlobalEventManager.removeAllEvents(this);
  };

  deregisterLineEvents = () => {
    const lines = this.getLines();
    for (const line of lines) {
      line.deregisterEvents();
    }
  };

  reInitEvents = () => {
    if (this.isHidden) {
      this.initEvents();
      this.isHidden = false;
      this.reInitLineEvents();
    }
  };

  reInitLineEvents = () => {
    //hide lines for slab images
    if (this.type !== MOVABLE_IMAGE_TYPES.slabImage) {
      for (const line of this.getLines()) {
        line.reInitEvents();
      }
    }
  };

  destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      for (const line of this.getLines()) {
        line.destroy();
      }
      if (this.resizablePoint) {
        this.resizablePoint.destroy();
      }
    }
  };

  stealCursor = function(who) {
    if (this === who) {
      EventManager.resetCursor(this);
    }
  };

  resetCursor = function(who) {
    void who;
    EventManager.resetCursor(this);
  };

  // getMidPoint(from, to) {
  //   return {
  //     x: from.x + (to.x - from.x)/2,
  //     y: from.y + (to.y - from.y)/2
  //   };
  // }

  isIE = function() {
    return (/Trident/i).test(window.navigator.appVersion);
  };

  getSrc = function(img) {
    if (img) {
      let src = img.getAttribute('src');
      if (src) {
        return src;
      }
      src = img.getAttribute("style");
      if (src) {
        return src.replace(/background-image: url\("\/api\/SqFtCalc\/GetImage\?url=/g, "").replace(/"\);/g, "");
      }
    }
    return "";
  };

  isSVG = (img) => {
    return (/data:image\/svg\+xml;base64,/).test(this.getSrc(img));
  };

  getPoints  = () => {
    return this.getLines().map(line => line.from);
  }

  getLinePointsPointField = () => {
    const points = this.getLines().map(line => line.from);
    return points.map(point => getPointField(point.x, point.y, this))
  }

  getPointsPointField = () => {
    return this.getLinePointsPointField()
  }

  getBorderPointsOnWorkspace = () => {
    const posField = this.getPosition();
    const points = this.getLines().map(line => line.from);
    return points.map(point => {
      return {
        x: posField.x + point.x,
        y: posField.y + point.y
      }
    })
  }

  getPointsPosOnWorkspace = () => {
    return this.getBorderPointsOnWorkspace();
  };

  createBorderPointsPosition = () => {
    return [
      getImagePoint(0, 0, this),
      getImagePoint(this.size.width, 0, this),
      getImagePoint(this.size.width, this.size.depth, this),
      getImagePoint(0, this.size.depth, this),
    ]

    // return [
    //   new point(0, 0, this),
    //   new point(this.size.width, 0, this),
    //   new point(this.size.width, this.size.depth, this),
    //   new point(0, this.size.depth, this),
    // ]
  }

  getLines = () => {
    return this.lines
  }

  getFrontLinesOnWorkspace = () => {
    return Array.isArray(this.lines) ? [this.lines[2]] : []
  }

  getPrevLine = (line) => {
    const index = this.lines.indexOf(line);
    if (index === -1) return null; // Line not found

    return this.lines[(index - 1 + this.lines.length) % this.lines.length]; // Loop back if it's the first line
  }

  getNextLine = (line) => {
    const index = this.lines.indexOf(line);
    if (index === -1) return null; // Line not found

    return this.lines[(index + 1) % this.lines.length]; // Loop back if it's the last line
  }

  getLinePoints = () => {
    return this.lines.map(line => line.from)
  }

  revealMeasurementsInsideShape = () => {
    for (const imageLine of this.getLines()) {
      imageLine.measurementInsideShape.revealEvents();
    }
  }

  hideMeasurementsInsideShape = () => {
    for (const imageLine of this.getLines()) {
      imageLine.measurementInsideShape.hideEvents();
    }
  }

  isAnyLineHovering = () => {
    const lines = this.getLines();
    for (const line of lines) {
      if (line.isHovering()) {
        return true
      }
    }

    return false
  }

  createLines = () => {
    return createImageLinesFromPoints(this.createBorderPointsPosition(), this);
  }

  shouldRenderMeasurementsInsideTheShape = () => {
    return APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE.includes(this.subType)
      && !hardCodeIsCaesarStone(); //CAES-547 remove measurements for the CaesarStone
  }

  getOuterShape = () => {
    const centerPos = this.getCenter();
    const centerPosOnField = getPointField(centerPos.x, centerPos.y, this);
    const shapes = workspace.getShapes(true);
    //let countInsidePoints;
    for (let shape of shapes) {
      //countInsidePoints = 0;
      if (shape instanceof sqftShape) {
        // for (let borderPoint of borderPoints) {
        //   if (isPointInsideShape(borderPoint, shape, true)) {
        //     countInsidePoints += 1
        //   }
        // }
        const isCenterInsideShape = isPointInsideShape(centerPosOnField, shape, true);
        if (isCenterInsideShape) {
          return shape
        }
        // if (countInsidePoints >= 2) {
        //   return shape
        // }
      }
    }

    return null
  }

  _render = (ctx) => {
    this.renderMovableImage.render(ctx);
  }
}

export default MovableImage;
